const HiddenCreditCardInput = () => {
	return (
		<>
			<label style={{ display: 'none' }}>
				HubspotCollectedFormsWorkaround
				https://community.hubspot.com/t5/APIs-Integrations/How-to-stop-collected-forms-from-collecting-a-form/m-p/299172#M28102
			</label>
			<input name="credit-card" style={{ display: 'none' }} required="" id="credit-card"></input>
		</>
	);
};

export default HiddenCreditCardInput;
